import * as client from "../ClientConsumer";
import {
    PostCommentInput,
    PostCommentsInfo,
} from "./PostCommentsService.types";
import { generatePath } from "react-router-dom";
import { RequestCriteriaType } from "./PostService.types";
import { prepareSearchCriteria } from "./ApiUtility";

const routes = {
    CREATE_POST_COMMENTS: "/posts/:postId/comments",
    COMMENT_EDIT: "/comments/:commentId",
    REACT_TO_COMMENT: "/comments/:commentId/reaction",
    UNREACT_TO_COMMENT: "/comments/:commentId/reaction/:reactionTypeName",
    COMMENT_DETAILS: "/comments/:id",
    GET_POST_COMMENTS: "/posts/:postId/comments",
    DELETE_COMMENT: "/comments/:commentId",
};

export async function getPostComments<IdType = number>(
    id: string,
    sortCriteria: RequestCriteriaType,
): Promise<PostCommentsInfo<IdType>[]> {
    return client
        .getData(
            generatePath(routes.GET_POST_COMMENTS, {
                postId: id,
            }) + prepareSearchCriteria(sortCriteria),
        )
        .then((res) => res.data);
}

export async function addComment(
    postId: string,
    {
        text,
        images,
        referencedComment,
        sourceType,
        linkoutUrl,
    }: PostCommentInput,
): Promise<PostCommentsInfo> {
    const input = {
        content: text,
        sourceType,
        linkoutUrl,
    };
    return client
        .postData(`${routes.CREATE_POST_COMMENTS.replace(":postId", postId)}`, {
            ...input,
            ...(images.length ? { imageList: images } : {}),
            ...(referencedComment
                ? { referencedComment: referencedComment }
                : {}),
        })
        .then((res) => res.data);
}

export async function editComment(
    commentId: string,
    {
        text,
        images,
        referencedComment,
        linkoutUrl,
        deleteImage,
    }: PostCommentInput,
): Promise<PostCommentsInfo> {
    const input = {
        content: text,
        linkoutUrl,
    };

    return client
        .putData(`${routes.COMMENT_EDIT.replace(":commentId", commentId)}`, {
            ...input,
            ...(images ? { imageList: images } : {}),
            ...(referencedComment
                ? { referencedComment: referencedComment }
                : {}),
            ...(deleteImage ? { deleteImage } : {}),
        })
        .then((res) => res.data);
}

export function deletePostComment(
    commentId: string,
): Promise<PostCommentsInfo> {
    return client
        .deleteData(routes.DELETE_COMMENT.replace(":commentId", commentId))
        .then((res) => res.data.result);
}

export function reactToComment(commentId: string, reactionTypeName: string) {
    return client
        .postData(
            generatePath(routes.REACT_TO_COMMENT, {
                commentId: commentId,
            }),
            {
                reactionTypeName: reactionTypeName,
            },
        )
        .then((response) => response.data);
}

export function unReactToComment(commentId: string, reactionTypeName: string) {
    return client
        .deleteData(
            generatePath(routes.UNREACT_TO_COMMENT, {
                commentId: commentId,
                reactionTypeName: reactionTypeName,
            }),
        )
        .then((response) => response.data);
}

export function getCommentDetails(id: string) {
    return client
        .getData(
            generatePath(routes.COMMENT_DETAILS, {
                id: id,
            }) + prepareSearchCriteria({}),
        )
        .then((response) => response.data);
}
